export default __webpack_public_path__ + "static/media/pie-chart.2c823c84.png";